'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'cloud';
var width = 576;
var height = 512;
var aliases = [9729];
var unicode = 'f0c2';
var svgPathData = 'M96 176c0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96l0 49.1c38.2 22.1 64 63.5 64 110.9l0 128-576 0 0-144c0-62.7 40.1-116 96-135.8L96 176zM240 48c-70.7 0-128 57.3-128 128l0 35.9-5.7 1.7C54 229.7 16 278.4 16 336l0 128 544 0 0-112c0-43-24.2-80.3-59.7-99.1l-4.3-2.3 0-58.7c0-44.2-35.8-80-80-80-17.6 0-33.8 5.7-47 15.2l-8 5.8-4-9c-19.9-44.8-64.8-76-117-76z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloud = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;